module.exports = {
	"app.name": "Gifbowl",
	"app.desc": "Like Fishbowl but Giffier",
	"app.intro": "Played Celebrity or Fishbowl before? This is like that, turned up a notch. Grab a group of friends, create your own cards, divide into teams, and start guessing. Do it. Don't let your dreams be dreams.",
	"game.tie": "It's all tied up!",
	"game.loading": "Game is loading",
	"home.start": "Start a new game",
	"home.join": "Join a game",
	"home.code": "Enter a game code",
	"home.footer": "Made by Viget. Powered by Giphy.",
	"game.start": "Start Game",
	"cards.title.placeholder": "Enter Card Title",
	"cards.add": "+ Add card to gifbowl",
	"round.start": "Start Next Round",
	"turn.desc": "Normally we would tell you what to do here. Sorry.",
	"turn.guess": "Correct",
	"turn.finished.advance": "Start Next Turn",
	"round.desc.1": "Describe Your Card",
	"round.desc.2": "Act Out Your Card",
	"round.desc.3": "One Word"
};


/*****************
 ** WEBPACK FOOTER
 ** ./web/static/config/strings.json
 ** module id = 7
 ** module chunks = 0
 **/